// extracted by mini-css-extract-plugin
export var label = "_cy-2";
export var slideContainer = "_cy-0";
export var slider = "_cy-1";